import { StyledContainer } from "./Container.style.js";
import { ContainerProps, DefaultContainerProps } from "./Container.types.js";

const defaultProps: DefaultContainerProps = {
    fluid: false,
};

export const Container = ({ children, ...props }: ContainerProps): JSX.Element => {
    const { ...attributes } = { ...defaultProps, ...props };

    return <StyledContainer {...attributes}>{children}</StyledContainer>;
};
